import { useMutation, useQueryClient } from "react-query";
import { updateLeasedEquipmentType } from "../../../../../actions/Utilities/LeasedEquipmentType";
import { toast } from "components/toastNotification";
import { IType } from "../types";

const useEditType = () => {
  const { mutate } = useMutation(
    (Data: IType) => updateLeasedEquipmentType(Data),
    {
      onSuccess: (res) => {
        switch (true) {
          case res == "Success":
            toast.fire("Success", "Type Updated Successfully", "success");
            break;
          case res.includes("Notification insert Failed"):
            toast.fire(
              "Success ",
              `Type Updated Successfully, BUT ${res}`,
              "warning"
            );
            break;
          case res == "Operation Failed!":
            toast.fire(
              "Updating Type failed ",
              `Server Error: ${res}`,
              "error"
            );
            break;
          case res == "The data already exists!":
            toast.fire(
              "Updating Type failed ",
              `Duplication Error: ${res}`,
              "error"
            );
            break;
          case res.includes("Action object"):
            toast.fire("Updating Type failed ", `Error: ${res}`, "error");
            break;
          default:
            toast.fire("Updating Type failed", `${res.Message}`, "error");
        }
      },
      onError: (error: any) => {
        toast.fire("Update Type failed", `Error: ${error}`, "error");
      },
    }
  );
  return mutate;
};

export default useEditType;
